/**
 * Shared movement type labels and icons for inventory UI.
 * Used by InventoryMovementPage and SerialDetailsModal.
 */
import {MovementType} from '../models/inventory.model';

export const getMovementTypeLabel = (type: string | MovementType): {label: string; color: string} => {
  const s = String(type).trim();
  const isSnakeCase = /^[a-z0-9_]+$/.test(s);
  if (!isSnakeCase && s.length > 0) {
    return {label: s, color: 'bg-gray-100 text-gray-700'};
  }
  const map: Record<string, {label: string; color: string}> = {
    [MovementType.STOCK_IN]: {label: 'إدخال مخزون', color: 'bg-green-100 text-green-700'},
    [MovementType.STOCK_OUT]: {label: 'إخراج مخزون', color: 'bg-red-100 text-red-700'},
    [MovementType.TRANSFER]: {label: 'نقل مخزون', color: 'bg-blue-100 text-blue-700'},
    [MovementType.ADJUSTMENT]: {label: 'تعديل مخزون', color: 'bg-yellow-100 text-yellow-700'},
    [MovementType.RETURN]: {label: 'إرجاع مخزون', color: 'bg-purple-100 text-purple-700'},
    [MovementType.DAMAGE]: {label: 'تلف مخزون', color: 'bg-orange-100 text-orange-700'},
    stock_in: {label: 'إدخال مخزون', color: 'bg-green-100 text-green-700'},
    stock_out: {label: 'إخراج مخزون', color: 'bg-red-100 text-red-700'},
    transfer: {label: 'نقل مخزون', color: 'bg-blue-100 text-blue-700'},
    adjustment: {label: 'تعديل مخزون', color: 'bg-yellow-100 text-yellow-700'},
    return: {label: 'إرجاع مخزون', color: 'bg-purple-100 text-purple-700'},
    damage: {label: 'تلف مخزون', color: 'bg-orange-100 text-orange-700'},
    marketer_sale: {label: 'بيع بواسطة مسوق', color: 'bg-purple-100 text-purple-700'},
    add_serial: {label: 'إضافة مخزون بسيريال', color: 'bg-green-100 text-green-700'},
    add_non_serial: {label: 'إضافة مخزون كمية', color: 'bg-green-100 text-green-700'},
    marketer_delivery: {label: 'تسليم مسوق', color: 'bg-blue-100 text-blue-700'},
    store_delivery: {label: 'تسليم متجر', color: 'bg-blue-100 text-blue-700'}
  };
  return map[s] ?? {label: 'حركة أخرى', color: 'bg-gray-100 text-gray-700'};
};

export const getMovementIcon = (type: string | MovementType): string => {
  const s = String(type).trim();
  const map: Record<string, string> = {
    [MovementType.STOCK_IN]: '📥',
    [MovementType.STOCK_OUT]: '📤',
    [MovementType.TRANSFER]: '🔄',
    [MovementType.ADJUSTMENT]: '⚖️',
    [MovementType.RETURN]: '↩️',
    [MovementType.DAMAGE]: '💥',
    stock_in: '📥',
    stock_out: '📤',
    transfer: '🔄',
    adjustment: '⚖️',
    return: '↩️',
    damage: '💥',
    marketer_sale: '🛒',
    add_serial: '📥',
    add_non_serial: '📥',
    marketer_delivery: '🚚',
    store_delivery: '🏪'
  };
  return map[/^[a-z0-9_]+$/.test(s) ? s : ''] ?? '📋';
};
